import React, { useEffect } from "react";

export const useRelativeMousePosition = (ref: React.RefObject<HTMLElement>) => {
  const [coordinatesRatio, setCoordinatesRatio] = React.useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const refCurrent = ref.current;

    const changeRatioByCoordinates = (clientX: number, clientY: number) => {
      if (!refCurrent) return;

      const { left, top, width, height } = refCurrent.getBoundingClientRect();

      const x = (clientX - left) / width;
      const y = (clientY - top) / height;

      if (x >= 0 && x <= 1 && y >= 0 && y <= 1) {
        setCoordinatesRatio({ x, y });
      }
    };

    const handleMouseMove = (e: MouseEvent) => {
      changeRatioByCoordinates(e.clientX, e.clientY);
    };

    const handleTouchMove = (e: TouchEvent) => {
      changeRatioByCoordinates(e.touches[0].clientX, e.touches[0].clientY);
    };

    refCurrent?.addEventListener("touchmove", handleTouchMove, {
      passive: true,
    });
    refCurrent?.addEventListener("mousemove", handleMouseMove);

    return () => {
      refCurrent?.removeEventListener("touchmove", handleTouchMove);
      refCurrent?.removeEventListener("mousemove", handleMouseMove);
    };
  }, [ref]);

  return { coordinatesRatio };
};
